import { Pipe, PipeTransform } from '@angular/core';
import { DprActivityInlineCustomDataReport } from '@report/models';

@Pipe({
  name: 'isCustomDataInline',
})
export class IsCustomDataInlinePipe implements PipeTransform {
  transform(
    customDataId: number,
    inlineCustomData: DprActivityInlineCustomDataReport[]
  ): boolean {
    const inlineCustomDataIds = inlineCustomData.map((cd) => cd.id);

    return inlineCustomDataIds.includes(customDataId);
  }
}
